import { TRACKING_TOGGLE_SAVE } from '../../areas/user/actions/tracking';

import {
  readRecentlyVisited,
  writeRecentlyVisited,
  deleteRecentlyVisited,
} from './storage';

// This reducer does not store any data. It reads directly from localStorage,
// as does any component that requires recent visit data.

const MAX_ITEMS = 100;

export default (state, action) => {
  if (!state) {
    return {
      trackingEnabled: undefined,
    };
  }

  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      return {
        ...state,
        trackingEnabled: action.market.trackingToggles.find(
          t => t.name === 'personalization'
        ).default,
      };
    }

    case 'SESSION_RECEIVE': {
      if (action.privacyCookie.personalization === undefined) {
        return state;
      }

      return {
        ...state,
        trackingEnabled: action.privacyCookie.personalization,
      };
    }

    case TRACKING_TOGGLE_SAVE: {
      if (!action.settings.personalization) {
        deleteRecentlyVisited();
      }
      break;
    }

    case 'ROUTE_LOADED': {
      if (
        !action.route ||
        !state.trackingEnabled ||
        action.route.name !== 'product' ||
        // action.data.product is null if the product doesn't exist.
        !action.data?.product
      ) {
        return state;
      }

      const id = action.data.product.id;
      // Date.now() returns a timestamp, which is what we *want*, because the value
      // will be serialized as JSON.
      const date = Date.now();

      const recentlyVisited = readRecentlyVisited();
      const { products } = recentlyVisited;

      const nextProducts = [{ id, date }]
        .concat(products.filter(p => p.id !== id))
        .slice(0, MAX_ITEMS);

      const nextRecentlyVisited = {
        ...recentlyVisited,
        products: nextProducts,
      };

      writeRecentlyVisited(nextRecentlyVisited);

      break;
    }
    default:
      break;
  }

  return state;
};
